@if (action(); as action) {
  <p class="action f-body-s">
    {{ action | translate }}
  </p>
}

<div class="keys">
  @for (key of keys(); track key) {
    <div class="key f-body-xs" [class]="color()">
      {{ key | onyxCapitalize }}
    </div>
  }
</div>
